import styles from "./ReferalProgress.module.scss";
import checkIcon from "./icons/check.png";
import checkFreeIcon from "./icons/check-free.png";
import { FC } from "react";
import { formatNumberWithSpaces } from "../../../utils/numbers";
import { useSelector } from "../../../hooks";
import { ReferalProgressBar } from "./ReferalProgressBar";

interface IReferalProgressProps {
    exp: number;
}

export const ReferalProgress: FC<IReferalProgressProps> = ({ exp }) => {
    const milestones = useSelector(store => store.referals.milestones);

    const calculateProgressWidth = (exp: number) => {
        if (exp >= milestones[milestones.length - 1].exp)
            return 100;

        if (exp <= milestones[0].exp)
            return (exp / milestones[0].exp) * 30;
        
        for (let i = 1; i < milestones.length; i++) {
            if (exp <= milestones[i].exp) {
                const segmentStart = milestones[i - 1].exp;
                const segmentEnd = milestones[i].exp;
                const segmentRatio = (exp - segmentStart) / (segmentEnd - segmentStart);
                
                const positionStart = 30 + (i - 1) * 20;
                const positionEnd = i === milestones.length - 1 ? 100 : 30 + i * 20;
                
                return positionStart + segmentRatio * (positionEnd - positionStart);
            }
        }
        return 100;
    };

    const progressWidth = calculateProgressWidth(exp);
    
    return (
        <div className={styles.progressBarBlock}>
            <div className={styles.labels}>
                <span className={styles.labelsText}>Опыт:</span>
                
                {milestones.map((milestone, index) => (
                    <span key={index}>{formatNumberWithSpaces(milestone.exp)}</span>
                ))}
            </div>

            <div className={styles.track}>                
                <div
                    className={styles.progress}
                    style={{ width: `${progressWidth}%` }}
                ></div>
                
                {milestones.map((milestone, index) => (
                    <img
                        key={`exp${index}`}
                        className={`${styles.checkIcon} ${styles[`checkIcon${index + 1}`]}`}
                        src={exp >= milestone.exp ? checkIcon : checkFreeIcon}
                        alt="✔"
                    />
                ))}
            </div>

            <ReferalProgressBar milestones={ milestones.map(item => item.ticketsCount) } type='tickets' />
            <ReferalProgressBar milestones={ milestones.map(item => item.fragmentsCount ?? 0) } type='fragments' />
        </div>
    );
}